import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['selectedRecord']
  static values = {
    content: String
  }

  render(event) {
    const [_data, _status, xhr] = event.detail

    this.contentValue = xhr.response

    this.renderContent()
  }

  renderContent() {
  const element = this.selectedRecordTargets.find(x => x.id === this.id)
    const parser = new DOMParser()
    const doc = parser.parseFromString(this.contentValue, 'text/html')
    element.innerHTML = doc.body.innerHTML
  }

  get id() {
    return event.currentTarget.dataset.id
  }
}
